const appSpinnerVisible = state => state.appSpinnerVisible;

export default {
  appSpinnerVisible
};
